export default "__VITE_PUBLIC_ASSET__2e93f08e__"